import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const navigate = useNavigate();
  const whatsappGroupLink = 'https://chat.whatsapp.com/CAsrkjCEANc4f9unrUxkn0';

  const handleCommunityClick = () => {
    navigate('/community');
    setShowTooltip(false);
  };

  const handleDirectJoin = () => {
    window.open(whatsappGroupLink, '_blank');
    setShowTooltip(false);
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-16 sm:bottom-20 right-0 bg-gray-900 border-2 border-green-500 rounded-lg p-3 sm:p-4 w-56 sm:w-64 shadow-2xl animate-fade-in">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-white"
            >
              <FaTimes />
            </button>
            <div className="flex items-start space-x-2 sm:space-x-3">
              <div className="bg-green-500 p-2 rounded-full flex-shrink-0">
                <FaWhatsapp className="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h4 className="text-white font-bold mb-1 text-sm sm:text-base">Join Our Community</h4>
                <p className="text-gray-400 text-xs sm:text-sm mb-2 sm:mb-3">
                  Connect with 500+ fitness enthusiasts and get daily motivation!
                </p>
                <div className="space-y-2">
                  <button
                    onClick={handleDirectJoin}
                    className="bg-green-500 hover:bg-green-600 text-white px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-bold transition-all w-full flex items-center justify-center space-x-2"
                  >
                    <FaWhatsapp />
                    <span>Join WhatsApp</span>
                  </button>
                  <button
                    onClick={handleCommunityClick}
                    className="bg-gray-700 hover:bg-gray-600 text-white px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-bold transition-all w-full"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Button */}
        <button
          onClick={() => setShowTooltip(!showTooltip)}
          className="bg-green-500 hover:bg-green-600 text-white p-3 sm:p-4 rounded-full shadow-2xl transition-all transform hover:scale-110 animate-bounce-slow border-2 sm:border-4 border-green-400"
          title="Join Gym Community"
        >
          <FaWhatsapp className="text-2xl sm:text-3xl" />
        </button>

        {/* Pulse Effect */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20"></div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }

        .animate-bounce-slow {
          animation: bounce-slow 2s infinite;
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;
